import Modal from "./components/modal";
import Rails from "@rails/ujs";

export const CheckoutPaymentAndShippingView = {

  init: function() {
    let value = $('#price_after_credit_usage').val();

    if ($('#use_credits').is(':checked') && value == 0.0) {
      $('.payments').hide();
      $('.credit-payment').show();
    }
    else {
      $('.credit-payment').hide();
      $('.payments').show();
    }

    CheckoutPaymentAndShippingView.credits();
  },

  credits: function() {
    $('#use_credits').on('click.mixit', function () {
      let value = $('#price_after_credit_usage').val();

      if ($('#use_credits').is(':checked') && value == 0.0) {
        $('.payments').hide();
        $('.credit-payment').show();
        $('.credit-payment input:radio[name=payment_id]').prop('checked', true)
      }
      else {
        $('.credit-payment').hide();
        $('.payments').show();
        $('.credit-payment input:radio[name=payment_id]').prop('checked', false)
      }
    });
  }
};

export const CheckoutOverview = {

  init: function() {
    $('#confirm-order-btn').on('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if($('#agree-with-terms_checkbox').is(':checked')) {
        let form = document.getElementById("new_order");
        Rails.fire(form, 'submit');
      }
      else {
        Modal.showOkModal('', $('#agree-with-terms_checkbox').data('errorMessage'));
      }
    });
  },

  validation: function() {
    $(document).ready(function(){
      $("#new_order").validate({
        rules: {
          'customer[agree_with_terms]': {
            required: true
          }
        }
      });
    });
  }
};
